import { render } from "./treatementEmergentAE.vue?vue&type=template&id=3c00e75e&scoped=true"
import script from "./treatmentEmergentAE.js?vue&type=script&lang=js"
export * from "./treatmentEmergentAE.js?vue&type=script&lang=js"

import "./treatementEmergentAE.vue?vue&type=style&index=0&id=3c00e75e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c00e75e"]])

export default __exports__